import moment from 'moment';

export function appendHtml(el: Node, str: string) {
  const div = document.createElement('div'); //container to append to
  div.innerHTML = str;
  while (div.children.length > 0) {
    el.appendChild(div.children[0]);
  }
}

export function GetSafeValue(value: string | number | undefined): string | number | undefined { return (value == "<p><br></p>" || value === "" || value === undefined || value === "undefined" || value === null || value === "null" ? "" : value) }


export function formatDate(date: Date | string) {
  moment.locale('pt-br');
  return moment(date).format('DD/MM/YYYY');
}

export function formatDateTime(date: Date | string) {
  moment.locale('pt-br');
  return moment(date).format('DD/MM/YYYY HH:mm');
}

export function formatCPF(input: string) {
  const digits = input.replace(/\D/g, '');

  if (digits.length !== 11) {
    throw new Error("Input must have exactly 11 digits");
  }

  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9, 11)}`;
}

export function cardMask(/* value: string */) {
  return "9999 9999 9999 9999";
}

export function cvvMask(/* value: string */) {
  return "999";
}

export function telefoneMask(value: string) {
  if(value == null)return value
  const digits = value.replace(/\D/g, '');
  if (digits.length <= 10) {
    return digits.replace(/(\d{2})(\d{4})(\d{0,4})/, (match, p1, p2, p3) => 
      `(${p1})${p2}${p3 ? '-' + p3 : ''}`
    );
  } else {
    return digits.replace(/(\d{2})(\d{5})(\d{0,4})/, (match, p1, p2, p3) => 
      `(${p1})${p2}${p3 ? '-' + p3 : ''}`
    );
  }
}

export function cpfCnpjMask(value: string) {
  const digits = value.replace(/\D/g, '');
  if (digits.length <= 11) {
    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, (match, p1, p2, p3, p4) => 
      `${p1}.${p2}.${p3}${p4 ? '-' + p4 : ''}`
    );
  } else {
    return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2})/, (match, p1, p2, p3, p4, p5) => 
      `${p1}.${p2}.${p3}/${p4}${p5 ? '-' + p5 : ''}`
    );
  }
}

export function convertToDateInput(date: Date | null) {
  if (!date || isNaN(date.getTime())) return "";
  return date.toISOString().split("T")[0];
}

export function toArray<T>(value: T | T[]): T[] {
  return Array.isArray(value) ? value : [value];
}